// Pure Pro India - Real Product Data from PurePro USA & PurePro India

export interface Product {
  id: string;
  name: string;
  category: "ionizers" | "ro-systems" | "hydrogen" | "filters" | "ro-filters" | "perfect-water";
  tagline: string;
  description: string;
  longDescription?: string;
  price?: string;
  features: string[];
  benefits?: string[];
  specifications?: { label: string; value: string }[];
  filtrationStages?: { stage: number; name: string; description: string }[];
  applications?: string[];
  imageUrl: string;
  isBestSeller?: boolean;
  bestSellerRank?: number;
}

export const products: Product[] = [
  // Water Ionizers
  {
    id: "ja-103",
    name: "Water Ionizer JA-103",
    category: "ionizers",
    tagline: "Entry Level Ionizer",
    description: "Alkaline Ionised Water System – the perfect entry point for families starting their alkaline water journey. PurePro JA-103 produces ionised water of about 10.0 pH or higher, depending on your water source.",
    longDescription: "Alkaline Ionised Water is one of the greatest preventative health advances and technological marvels of the 21st century. The PurePro JA-103 comes with polymer ion-plated platinum coated titanium ionising plates (est. life 20 years, latest Japanese University technology). It produces an Ionised Water of about 10.0 pH or higher, depending on your water source. Regarding quality and ionisation strength, the PurePro Water Ionizer is comparable to any ioniser on the market. Drinking antioxidant alkaline water is probably the single most important thing you can do for your health and well-being. PurePro Water Ionizer is currently manufactured in Taiwan and is one of the best-selling water ionisers available worldwide.",
    price: "₹95,000",
    features: [
      "Platinum-Coated Titanium Electrodes",
      "Electrolysis Chamber Area: 500 cm²",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by Silver Coated Activated Carbon Filter",
      "LCD Display with pH & ORP Indicators",
      "Built-in Auto-Flushing Electrode",
      "Auto-Cleaning Function",
      "Easy Countertop Installation",
    ],
    benefits: [
      "Flushes excess toxins from your body",
      "Powerful antioxidant properties – neutralises free radicals",
      "Improves hydration with smaller water molecule clusters",
      "Restores the body's natural pH balance",
      "Enhances nutrient absorption",
      "Supports immune system health",
      "Acid water output useful for skin care and cleaning",
    ],
    specifications: [
      { label: "Model", value: "JA-103" },
      { label: "MRP", value: "₹95,000" },
      { label: "Type", value: "Alkaline Water Ionizer" },
      { label: "Voltage", value: "AC-110V / AC-220V" },
      { label: "Electricity", value: "DC 2A~6A" },
      { label: "Electrolysis Chamber", value: "500 cm²" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "ORP Level", value: "+500 mV to −400 mV" },
      { label: "Filtration Capacity", value: "12,000 Litres" },
      { label: "Dimensions", value: "31.5 (L) × 27.5 (W) × 14 (H) cm" },
      { label: "Weight", value: "4.5 kg" },
      { label: "Plate Life", value: "Est. 20 years" },
      { label: "Made In", value: "Taiwan (Japanese Technology)" },
    ],
    applications: [
      "Daily drinking water for the whole family",
      "Cooking – enhances taste of food and beverages",
      "Acid water for skin toning and household cleaning",
    ],
    imageUrl: "/images/products/ja-103.jpg",
  },
  {
    id: "ja-303",
    name: "Water Ionizer JA-303",
    category: "ionizers",
    tagline: "Popular Choice – Great Selling in USA",
    description: "Alkaline Ionised Water System with enhanced features for medium to large families. Produces ionised water up to 10.0 pH with polymer ion-plated platinum coated titanium plates.",
    longDescription: "The PurePro JA-303 is a great-selling model in the USA and worldwide. Alkaline Ionised Water is one of the greatest preventative health advances of the 21st century. The JA-303 comes with polymer ion-plated platinum coated titanium ionising plates (est. life 20 years, latest Japanese University technology). It produces an Ionised Water of about 10.0 pH or higher, depending on your water source. The stylish upright design features a full electronic LED panel with water flow, pH, and ORP display indicators. Built-in auto-flushing electrode ensures extended plate lifespan with unique post-operation automatic and silent cleansing.",
    price: "₹1,15,000",
    features: [
      "Platinum-Coated Titanium Electrodes",
      "Electrolysis Chamber Area: 750 cm²",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by Silver Coated Activated Carbon Filter",
      "Voice Guide System",
      "Full Electronic LED Panel",
      "Water Flow, pH & ORP Display Indicators",
      "Built-in Auto-Flushing Electrode",
      "Post-Operation Automatic Silent Cleansing",
      "Touch Controls",
      "Stainless Steel Output Spout",
    ],
    benefits: [
      "Flushes excess toxins from your body",
      "Powerful antioxidant – neutralises harmful free radicals",
      "Smaller molecular water clusters for better hydration",
      "Restores body's natural pH balance",
      "Acid water for external skin care and household use",
      "Hydrogen-rich water production",
    ],
    specifications: [
      { label: "Model", value: "JA-303" },
      { label: "MRP", value: "₹1,15,000" },
      { label: "Type", value: "Alkaline Water Ionizer" },
      { label: "Voltage", value: "AC-110V / AC-220V" },
      { label: "Electricity", value: "DC 2A~6A" },
      { label: "Electrolysis Chamber", value: "750 cm²" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "ORP Level", value: "+500 mV to −400 mV" },
      { label: "Filtration Capacity", value: "12,000 Litres" },
      { label: "Dimensions", value: "31.5 (L) × 27.5 (W) × 14 (H) cm" },
      { label: "Weight", value: "4.7 kg" },
      { label: "Plate Life", value: "Est. 20 years" },
      { label: "Made In", value: "Taiwan (Japanese Technology)" },
    ],
    applications: [
      "Daily drinking water for medium to large families",
      "Cooking and food preparation",
      "Acid water for skin care & cleaning purposes",
      "Hydrogen-rich water for health-conscious individuals",
    ],
    imageUrl: "/images/products/ja-303.jpg",
  },
  {
    id: "ja-503",
    name: "Water Ionizer JA-503",
    category: "ionizers",
    tagline: "Best Seller #2 – 5 Platinum Titanium Plates",
    description: "Alkaline Ionised Water System with 5 platinum-titanium plates, ORP & pH display, and premium features. Our second most popular model trusted by families across India.",
    longDescription: "The PurePro JA-503 features 5 polymer ion-plated platinum coated titanium ionising plates with an electrolysis chamber area of 750 cm² (est. life 20 years, latest Japanese University technology). It produces an Ionised Water of about 10.0 pH or higher, depending on your water source. The stylish upright look comes with a full electronic LED panel featuring water flow display, pH display, and ORP display indicators. The built-in auto-flushing electrode with unique post-operation automatic and silent cleansing ensures extended plate lifespan. Comparable in quality and ionisation strength to any ioniser on the market, including Kangen water systems.",
    price: "₹1,25,000",
    features: [
      "5 Platinum-Coated Titanium Electrode Plates",
      "Electrolysis Chamber Area: 750 cm²",
      "ORP & pH Display Indicators",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by Silver Coated Activated Carbon Filter",
      "Full Electronic LED Panel",
      "Water Flow Display Indicator",
      "Built-in Auto-Flushing Electrode",
      "Post-Operation Automatic Silent Cleansing",
      "Stainless Steel Output Spout",
      "Voice Guidance System",
      "Hydrogen-Rich Water Output",
    ],
    benefits: [
      "5-plate system for superior ionisation strength",
      "Powerful antioxidant – fights free radicals effectively",
      "Flushes toxins from the body",
      "Smaller water molecule clusters for improved cellular hydration",
      "Restores body's alkaline pH balance",
      "Acid water useful for skin toning and surface cleaning",
      "Hydrogen-rich water for enhanced health benefits",
    ],
    specifications: [
      { label: "Model", value: "JA-503" },
      { label: "MRP", value: "₹1,25,000" },
      { label: "Plates", value: "5 Platinum-Titanium" },
      { label: "Voltage", value: "AC-110V / AC-220V" },
      { label: "Electricity", value: "DC 2A~6A" },
      { label: "Electrolysis Chamber", value: "750 cm²" },
      { label: "Power Consumption", value: "100–200W (max 320W)" },
      { label: "ORP Level", value: "+500 mV to −400 mV" },
      { label: "Filtration Capacity", value: "12,000 Litres" },
      { label: "Dimensions", value: "31.5 (L) × 27.5 (W) × 14 (H) cm" },
      { label: "Weight", value: "4.7 kg" },
      { label: "Plate Life", value: "Est. 20 years" },
      { label: "In-Water Pressure", value: "1–6.5 kg/cm²" },
      { label: "Made In", value: "Taiwan (Japanese Technology)" },
    ],
    applications: [
      "Premium daily drinking water for health-conscious families",
      "Cooking and tea/coffee preparation",
      "Beauty and skin care with acid water",
      "Household cleaning with super-oxide water",
    ],
    imageUrl: "/images/products/ja-503.jpg",
    isBestSeller: true,
    bestSellerRank: 2,
  },
  {
    id: "ja-703",
    name: "Water Ionizer JA-703",
    category: "ionizers",
    tagline: "⭐ #1 Best Seller – 7 Platinum Titanium Plates",
    description: "PurePro's most powerful antioxidant machine – featuring 7 platinum-dipped titanium plates for improved water ionisation and increased antioxidant production. Produces ionised water of about 11.0 pH or higher!",
    longDescription: "The world's number one water ioniser is the PurePro JA-703. It comes with 7 large platinum coated 99.97% pure titanium plates with an electrolysis chamber area of 1368 cm² (est. life 20 years, latest Japanese University technology). It produces an Ionised Water of about 11.00 pH or higher, depending on your water source. Innovative electrolysis technology with 7 platinum-coated 99.97% pure titanium electrode plates delivers the highest and most constant pH with high negative ORP. More plates in a water ioniser means higher negative ORP level and more hydrogen gas bubbles. PurePro JA-703 is comparable in quality to Kangen water Enagic SD501 and Life Ionizer 8100. Drinking antioxidant alkaline hydrogen-rich water is the single most important thing you can do for your health.",
    price: "₹1,75,000",
    features: [
      "7 Platinum Pure Titanium Plates, 1368 cm²",
      "Highest & Constant pH (up to 11.0+)",
      "High Negative ORP (up to −700 mV)",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by Silver Coated Activated Carbon Filter",
      "Stainless Steel Output Spout",
      "Full Electronic LED Panel",
      "Water Flow, pH & ORP Display Indicators",
      "Built-in Auto-Flushing Electrode",
      "Post-Operation Automatic Silent Cleansing",
      "Sound Confirmation for All Operations",
      "Easy-Access Front Filter Compartment",
      "Optional Direct Plumbing Connection",
      "Maximum Hydrogen Gas Production",
    ],
    benefits: [
      "Most powerful antioxidant machine in the PurePro range",
      "7-plate system produces the highest negative ORP for maximum free radical neutralisation",
      "Maximum hydrogen gas bubbles for superior health benefits",
      "Flushes excess toxins from the body effectively",
      "Smaller molecular clusters for deeper cellular hydration",
      "Comparable to Kangen Enagic SD501 at a fraction of the cost",
      "Acid water for skin care, beauty treatments, and cleaning",
      "Lifetime electrode warranty for peace of mind",
    ],
    specifications: [
      { label: "Model", value: "JA-703" },
      { label: "MRP", value: "₹1,75,000" },
      { label: "Plates", value: "7 Platinum-Titanium (99.97% pure)" },
      { label: "Voltage", value: "AC-110V / AC-240V" },
      { label: "Electricity", value: "DC 2A~6A" },
      { label: "Electrolysis Chamber", value: "1368 cm²" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "ORP Level", value: "+500 mV to −700 mV" },
      { label: "pH Range", value: "Up to 11.0+" },
      { label: "Filtration Capacity", value: "12,000 Litres" },
      { label: "Dimensions", value: "31.5 (H) × 25.5 (W) × 13.5 (L) cm" },
      { label: "Weight", value: "5.5 kg" },
      { label: "Plate Life", value: "Est. 20 years" },
      { label: "Made In", value: "Taiwan (Japanese Technology)" },
    ],
    applications: [
      "Premium daily drinking water for the entire family",
      "Cooking, rice washing, and tea/coffee – enhanced flavour",
      "Beauty water (acid) for skin toning and hair rinsing",
      "Strong acid water for household disinfection",
      "Health-conscious individuals and wellness enthusiasts",
    ],
    imageUrl: "/images/products/ja-703.jpg",
    isBestSeller: true,
    bestSellerRank: 1,
  },
  // Nihon Trim Products (under ionizers)
  {
    id: "nihon-trim-gracia",
    name: "Nihon Trim Gracia",
    category: "ionizers",
    tagline: "Japan's #1 Under Sink Ionizer",
    description: "Nihon Trim is the leading Japanese water ionizer with 65% market share. The Gracia model produces alkaline hydrogenated water with hot and cold output from an elegant gro faucet with hand shower.",
    features: [
      "65% Market Share in Japan",
      "Alkaline Hydrogenated Water",
      "Hot & Cold Water Output",
      "Elegant Faucet with Hand Shower",
      "Medical Grade Quality",
      "Double Auto-Change Cross-Line System",
    ],
    benefits: [
      "Under-sink installation for a clean kitchen look",
      "Hot and cold alkaline water on demand",
      "Medical device certified in Japan",
      "40+ years of proven Japanese technology",
    ],
    imageUrl: "/images/nihon-trim/gracia-faucet.jpg",
  },
  {
    id: "nihon-trim-ti",
    name: "Nihon Trim TI-10 / TI-30",
    category: "ionizers",
    tagline: "Commercial Water Ionizer",
    description: "Nihon Trim TI-10/TI-30 commercial water ionizers designed for high-volume applications. Provides 500 LPH / 1500 LPH with 24 hours continuous operation for commercial and industrial use.",
    features: [
      "TI-10: 500 LPH Capacity",
      "TI-30: 1500 LPH Capacity",
      "24/7 Continuous Operation",
      "Commercial Grade Durability",
      "Industrial Applications",
    ],
    benefits: [
      "Ideal for hospitals, hotels, and large facilities",
      "Continuous operation without downtime",
      "Medical device certified in Japan",
    ],
    imageUrl: "/images/nihon-trim/ti-10-30.jpg",
  },
  {
    id: "ja-2000",
    name: "Water Ionizer JA-2000",
    category: "ionizers",
    tagline: "Flagship Model",
    description: "Our flagship Alkaline Ionised Water System with the most advanced technology, premium design, and touch screen display. Features polymer ion-plated platinum coated titanium plates.",
    longDescription: "The PurePro JA-2000 is the flagship of the PurePro Water Ionizer range. It features polymer ion-plated platinum coated titanium ionising plates with an electrolysis chamber area of 750 cm² (est. life 20 years, latest Japanese University technology). It produces an Ionised Water of about 10.0 pH or higher, depending on your water source. The JA-2000 boasts a premium touch screen display, the most advanced controls, and a refined design for discerning users who demand the very best in alkaline water technology.",
    price: "₹1,85,000",
    features: [
      "Premium Platinum-Coated Titanium Electrode Plates",
      "Electrolysis Chamber Area: 750 cm²",
      "Touch Screen Display",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by Silver Coated Activated Carbon Filter",
      "Highest H₂ Concentration in Its Class",
      "Maximum Electrode Surface Area",
      "Built-in Auto-Flushing Electrode",
      "Premium Build Quality & Design",
      "Voice Guidance System",
    ],
    benefits: [
      "Flagship technology for the best ionisation experience",
      "Touch screen for intuitive, modern operation",
      "Powerful antioxidant water for improved health",
      "Hydrogen-rich water for cellular hydration",
      "Premium aesthetics complement modern kitchens",
    ],
    specifications: [
      { label: "Model", value: "JA-2000" },
      { label: "MRP", value: "₹1,85,000" },
      { label: "Type", value: "Premium Alkaline Ionizer" },
      { label: "Voltage", value: "AC-110V / AC-220V" },
      { label: "Electricity", value: "DC 2A~6A" },
      { label: "Electrolysis Chamber", value: "750 cm²" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "ORP Level", value: "+500 mV to −400 mV" },
      { label: "Filtration Capacity", value: "12,000 Litres" },
      { label: "Dimensions", value: "31.5 (L) × 27.5 (W) × 14 (H) cm" },
      { label: "Weight", value: "4.7 kg" },
      { label: "Plate Life", value: "Est. 20 years" },
      { label: "Made In", value: "Taiwan (Japanese Technology)" },
    ],
    applications: [
      "Premium households and modern kitchens",
      "Health-conscious families seeking the best ionisation",
      "Cooking, beverages, and daily hydration",
      "Wellness centres and clinics",
    ],
    imageUrl: "/images/products/ja-2000.jpg",
  },

  // RO Systems
  {
    id: "ers-106uv",
    name: "ERS-106UV",
    category: "ro-systems",
    tagline: "6-Stage RO + UV Steriliser",
    description: "6-Stage Quick-Change Reverse Osmosis System with Ultraviolet Steriliser for complete water purification. Simply the best of the best – change filters with a single ¼ turn twist!",
    longDescription: "This revolutionary PurePro 6-stage system uses Reverse Osmosis, UV Sterilisation, and Carbon Filtration to put refreshing, clean water at your fingertips. The Quick-Change cartridge design uses the most advanced water treatment technology. RO is recognised as one of the best available methods for improving water quality. PurePro Quick-Change RO's unique twist and quick-change cartridge design makes filter changes fast, clean, and easy – much quicker than traditional systems. The UV steriliser provides an additional layer of protection by eliminating 99.99% of bacteria and viruses.",
    features: [
      "6-Stage Filtration with UV Steriliser",
      "Quick-Change ¼ Turn Twist Filter Design",
      "50 GPD TFC RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "UV Lamp Eliminates 99.99% Bacteria & Viruses",
      "Automatic Shut-off Valve",
      "Stainless Steel Check Valve",
      "Long Reach Chrome Faucet",
      "100% Factory Tested & Sterilised",
      "Completely Assembled – Ready for Installation",
    ],
    benefits: [
      "Complete purification: RO removes contaminants, UV kills remaining microorganisms",
      "Quick-change design saves time and eliminates mess during filter replacement",
      "Removes lead, copper, barium, chromium, mercury, sodium, and other contaminants",
      "NSF-standard tank ensures safe water storage",
      "Ideal for areas with bacterial contamination in water supply",
    ],
    filtrationStages: [
      { stage: 1, name: "5 Micron Sediment Filter", description: "Effectively removes dirt, rust, and sand particles with five micron rating." },
      { stage: 2, name: "Granular Activated Carbon Filter", description: "Removes 99% of chlorine and organic chemicals. Provides enhanced reduction of taste, odour, and colour." },
      { stage: 3, name: "Granular Activated Carbon Filter", description: "Further removes remaining chlorine, taste, odour, and colour for thorough pre-treatment." },
      { stage: 4, name: "Reverse Osmosis Membrane (TFC)", description: "High quality 50 GPD thin film composite membrane removes lead, copper, barium, chromium, mercury, sodium, and other contaminants." },
      { stage: 5, name: "Post Carbon Filter", description: "Post carbon filter removes objectionable tastes and odours to enhance the quality of drinking water." },
      { stage: 6, name: "UV Steriliser", description: "Ultraviolet steriliser eliminates 99.99% of bacteria and viruses for complete microbiological safety." },
    ],
    specifications: [
      { label: "Model", value: "ERS-106UV" },
      { label: "Stages", value: "6 Stage (RO + UV)" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "UV Steriliser", value: "Included" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "8 kg" },
      { label: "Tank Weight", value: "4 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Homes with high bacterial contamination in water",
      "Under-sink installation for kitchen use",
      "Office and commercial drinking water",
    ],
    imageUrl: "/images/products/ers-106uv.jpg",
  },
  {
    id: "ers-105",
    name: "ERS-105",
    category: "ro-systems",
    tagline: "Best Seller – Quick-Change RO",
    description: "Simply the best of the best! Change filters with a single ¼ turn twist – much quicker than traditional systems. PurePro Quick-Change RO uses the most advanced water treatment technology.",
    longDescription: "PurePro® Quick-Change RO system uses the most advanced water treatment technology: Reverse Osmosis. RO is recognised as one of the best available methods for improving water quality. The unique twist and quick-change cartridge design makes filter changes fast, clean, and easy. This 5-stage system is 100% factory tested and sterilised, completely assembled and ready for installation. Features a 50 GPD membrane made in the USA and a 3.2-gallon NSF Standards water storage tank.",
    features: [
      "Quick-Change ¼ Turn Twist Filter Design",
      "50 GPD TFC RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Automatic Shut-off Valve",
      "Mini Flow Restrictor",
      "Stainless Steel Check Valve",
      "Long Reach Chrome Faucet",
      "Four Colour-Coded ¼ inch Tubing",
      "100% Factory Tested & Sterilised",
      "Completely Assembled – Ready for Installation",
    ],
    benefits: [
      "Quickest filter change in the industry – no tools needed",
      "Removes heavy metals, chemicals, and dissolved solids",
      "Space-saving under-sink design",
      "NSF-standard components for guaranteed safety",
      "Low maintenance cost with long-lasting filters",
    ],
    filtrationStages: [
      { stage: 1, name: "5 Micron Sediment Filter", description: "Effectively removes dirt, rust, and sand particles." },
      { stage: 2, name: "Granular Activated Carbon Filter", description: "Removes 99% of chlorine and organic chemicals. Enhanced reduction of taste, odour, and colour." },
      { stage: 3, name: "Granular Activated Carbon Filter", description: "Further removes remaining chlorine, taste, odour, and colour." },
      { stage: 4, name: "Reverse Osmosis Membrane (TFC)", description: "50 GPD high quality membrane removes lead, copper, barium, chromium, mercury, sodium, and other contaminants." },
      { stage: 5, name: "Post Carbon Filter", description: "Removes objectionable tastes and odours to guarantee pure-tasting water." },
    ],
    specifications: [
      { label: "Model", value: "ERS-105" },
      { label: "Stages", value: "5 Stage" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "8 kg" },
      { label: "Tank Weight", value: "4 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Residential under-sink water purification",
      "Office and workplace drinking water",
      "Pre-filtration before water ionisers",
    ],
    imageUrl: "/images/products/ers-105.jpg",
  },
  {
    id: "ers-106m",
    name: "ERS-106M",
    category: "ro-systems",
    tagline: "6-Stage RO + Mineral Filter",
    description: "6-Stage Quick-Change RO with Mineral Filter. Simply the best – change filters with a single ¼ turn twist! The Mineral Filter adds essential minerals back to purified water.",
    longDescription: "This revolutionary 6-stage system uses Reverse Osmosis, Mineral Filter, and Carbon Filtration to put refreshing, mineralised, clean water at your fingertips. The Mineral Filter improves the quality of clean water by adding minerals necessary for healthy human development. It provides calcium (Ca²⁺: 34 mg/L), magnesium (Mg²⁺: 12 mg/L), sodium (Na⁺: 22 mg/L), and potassium (K⁺: 7 mg/L) – minerals commonly found in the best mineral waters worldwide. The Quick-Change cartridge design makes filter changes fast, clean, and easy.",
    features: [
      "6-Stage Filtration with Mineral Filter",
      "Quick-Change ¼ Turn Twist Filter Design",
      "Adds Essential Minerals (Ca, Mg, Na, K)",
      "50 GPD TFC RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Automatic Shut-off Valve",
      "Stainless Steel Check Valve",
      "Long Reach Chrome Faucet",
      "100% Factory Tested & Sterilised",
      "Completely Assembled – Ready for Installation",
    ],
    benefits: [
      "Mineral-enriched water tastes better than plain RO water",
      "Replenishes essential minerals removed during RO purification",
      "Quick-change design eliminates messy filter replacements",
      "Removes all harmful contaminants while retaining healthy minerals",
      "Mineral capacity: 6,000 litres per cartridge",
    ],
    filtrationStages: [
      { stage: 1, name: "5 Micron Sediment Filter", description: "Removes dirt, rust, and sand particles." },
      { stage: 2, name: "Granular Activated Carbon Filter", description: "Removes 99% of chlorine and organic chemicals." },
      { stage: 3, name: "Granular Activated Carbon Filter", description: "Further removes remaining chlorine, taste, and odour." },
      { stage: 4, name: "Reverse Osmosis Membrane (TFC)", description: "50 GPD membrane removes lead, copper, barium, chromium, mercury, sodium, and other hard water contaminants." },
      { stage: 5, name: "Post Carbon Filter", description: "Removes objectionable tastes and odours to guarantee pure-tasting water." },
      { stage: 6, name: "Mineral Filter", description: "Adds essential minerals (Ca²⁺: 34 mg/L, Mg²⁺: 12 mg/L, Na⁺: 22 mg/L, K⁺: 7 mg/L) for improved taste and health benefits." },
    ],
    specifications: [
      { label: "Model", value: "ERS-106M" },
      { label: "Stages", value: "6 Stage (RO + Mineral)" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Mineral Capacity", value: "6,000 Litres" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "9 kg" },
      { label: "Tank Weight", value: "4 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Families preferring mineral-enriched purified water",
      "Areas with low TDS water where mineral supplementation is needed",
      "Under-sink residential and office use",
    ],
    imageUrl: "/images/products/ers-106m.jpg",
  },
  {
    id: "ers-106r",
    name: "ERS-106R",
    category: "ro-systems",
    tagline: "6-Stage RO + Far-Infrared Filter",
    description: "6-Stage Quick-Change RO with Far-Infrared Filter. Activates water molecules in our body and improves oxygen levels! Premium performance with advanced design.",
    longDescription: "This revolutionary 6-stage system uses Reverse Osmosis, Infra-Red Filter, and Carbon Filtration to put refreshing, activated, clean water at your fingertips. The Far-Infrared filter activates water molecules in the body and improves oxygen levels. Far-Infrared technology helps to improve blood circulation, enhance metabolism, and promote cellular regeneration. No other system can give all three kinds of purification in a system that is so simple to maintain with the quick-change design.",
    features: [
      "6-Stage Filtration with Far-Infrared Filter",
      "Quick-Change ¼ Turn Twist Filter Design",
      "Far-Infrared Water Molecule Activation",
      "Improved Oxygen Levels in Water",
      "50 GPD TFC RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Automatic Shut-off Valve",
      "Stainless Steel Check Valve",
      "100% Factory Tested & Sterilised",
      "Completely Assembled – Ready for Installation",
    ],
    benefits: [
      "Far-Infrared technology activates water molecules for better absorption",
      "Improves oxygen levels in the body",
      "Enhances blood circulation and metabolism",
      "Promotes cellular regeneration and overall wellness",
      "Quick-change design for easy, mess-free maintenance",
    ],
    filtrationStages: [
      { stage: 1, name: "5 Micron Sediment Filter", description: "Removes dirt, rust, and sand particles with five micron rating." },
      { stage: 2, name: "Granular Activated Carbon Filter", description: "Removes 99% of chlorine and organic chemicals." },
      { stage: 3, name: "Granular Activated Carbon Filter", description: "Further removes remaining chlorine, taste, odour, and colour." },
      { stage: 4, name: "Reverse Osmosis Membrane (TFC)", description: "50 GPD high quality membrane removes heavy metals and dissolved contaminants." },
      { stage: 5, name: "Post Carbon Filter", description: "Post carbon to guarantee the taste of drinking water." },
      { stage: 6, name: "Far-Infrared Filter", description: "Activates water molecules in the body, improves oxygen levels, enhances blood circulation and metabolism." },
    ],
    specifications: [
      { label: "Model", value: "ERS-106R" },
      { label: "Stages", value: "6 Stage (RO + Far-Infrared)" },
      { label: "Special Filter", value: "Far-Infrared Filter" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "8 kg" },
      { label: "Tank Weight", value: "4 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Health-conscious households seeking activated water",
      "Individuals looking to improve blood circulation and metabolism",
      "Under-sink residential installation",
    ],
    imageUrl: "/images/products/ers-106r.jpg",
  },
  {
    id: "ers-106a",
    name: "ERS-106A",
    category: "ro-systems",
    tagline: "6-Stage RO + Alkaline Filter",
    description: "The Alkaline Filter changes acidic RO water into perfect alkaline ionised water. Balanced pH 8.0–9.5 for improved health and great taste.",
    longDescription: "This revolutionary 6-stage system combines Reverse Osmosis with an Alkaline Filter to produce perfectly balanced alkaline ionised water. The PurePro Alkaline Filter changes acidic RO water (typically pH 5–6) into perfect alkaline ionised water with a balanced pH of 8.0–9.5. The Alkaline Filter adds beneficial minerals and raises the pH, giving you the benefits of both pure RO water and alkaline ionised water in one compact system. Quick-Change cartridge design makes filter replacement fast and mess-free.",
    features: [
      "6-Stage Filtration with Alkaline Filter",
      "Quick-Change ¼ Turn Twist Filter Design",
      "Alkaline pH 8.0–9.5 Output",
      "Converts Acidic RO Water to Alkaline Ionised Water",
      "50 GPD TFC RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Automatic Shut-off Valve",
      "Stainless Steel Check Valve",
      "100% Factory Tested & Sterilised",
      "Completely Assembled – Ready for Installation",
    ],
    benefits: [
      "Alkaline water helps neutralise acidity in the body",
      "pH 8.0–9.5 is optimal for daily drinking",
      "Combines the purity of RO with the health benefits of alkaline water",
      "Adds essential minerals back to purified water",
      "Great taste compared to plain RO water",
      "Affordable alternative to standalone water ionisers",
    ],
    filtrationStages: [
      { stage: 1, name: "5 Micron Sediment Filter", description: "Removes dirt, rust, and sand particles." },
      { stage: 2, name: "Granular Activated Carbon Filter", description: "Removes 99% of chlorine and organic chemicals." },
      { stage: 3, name: "Granular Activated Carbon Filter", description: "Further removes remaining chlorine, taste, odour, and colour." },
      { stage: 4, name: "Reverse Osmosis Membrane (TFC)", description: "50 GPD membrane removes heavy metals, chemicals, and dissolved solids." },
      { stage: 5, name: "Post Carbon Filter", description: "Removes objectionable tastes and odours for pure-tasting water." },
      { stage: 6, name: "Alkaline Filter", description: "Changes acidic RO water into perfect alkaline ionised water with balanced pH 8.0–9.5. Adds essential minerals." },
    ],
    specifications: [
      { label: "Model", value: "ERS-106A" },
      { label: "Stages", value: "6 Stage (RO + Alkaline)" },
      { label: "pH Range", value: "8.0–9.5" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "8 kg" },
      { label: "Tank Weight", value: "4 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Families seeking alkaline water without a full ioniser investment",
      "Health-conscious households",
      "Under-sink residential and office installation",
    ],
    imageUrl: "/images/products/ers-106a.jpg",
  },
  {
    id: "ers-105-nf",
    name: "ERS-105-NF",
    category: "ro-systems",
    tagline: "Pre-Filtration System for Water Ionisers",
    description: "The premier pre-filtration system available for water ionisers today! Extends the life of your water ioniser and ensures optimal ionisation performance.",
    longDescription: "The PurePro ERS-105-NF is specifically designed as a pre-filtration system for water ionisers. By removing sediment, chlorine, and other contaminants before water enters the ioniser, this system extends the life of ioniser plates and ensures consistent ionisation performance. It uses a Nano-Filtration (NF) membrane that retains essential minerals while removing harmful contaminants – unlike standard RO membranes that strip all minerals. This makes it the ideal companion for any water ioniser.",
    features: [
      "Nano-Filtration (NF) Membrane Technology",
      "Retains Essential Minerals (unlike standard RO)",
      "Quick-Change ¼ Turn Twist Filter Design",
      "Extends Water Ioniser Plate Lifespan",
      "Removes Sediment, Chlorine & Contaminants",
      "High Flow Rate for Ioniser Compatibility",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Automatic Shut-off Valve",
      "100% Factory Tested & Sterilised",
      "Easy Installation",
    ],
    benefits: [
      "Protects your water ioniser investment by removing scale-causing minerals",
      "NF membrane retains healthy minerals for better ionisation",
      "Extends ioniser electrode life significantly",
      "Ensures consistent pH and ORP output from your ioniser",
      "Reduces maintenance frequency of your water ioniser",
    ],
    specifications: [
      { label: "Model", value: "ERS-105-NF" },
      { label: "Purpose", value: "Pre-Filtration for Water Ionisers" },
      { label: "Membrane Type", value: "Nano-Filtration (NF)" },
      { label: "Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Operation Pressure", value: "50–100 psi" },
      { label: "System Dimensions", value: "29 (L) × 42.5 (H) × 21 (W) cm" },
      { label: "Tank Dimensions", value: "28 (L) × 28 (W) × 35 (H) cm" },
      { label: "System Weight", value: "8 kg" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
    ],
    applications: [
      "Pre-filtration for PurePro Water Ionisers (JA-103, JA-303, JA-503, JA-703, JA-2000)",
      "Pre-filtration for any brand of water ioniser",
      "Areas with hard water or high TDS",
    ],
    imageUrl: "/images/products/ers-105-nf.jpg",
  },

  // Hydrogen Products
  {
    id: "hydrogen-generator",
    name: "Hydrogen Water Generator",
    category: "hydrogen",
    tagline: "Undersink Hydrogen Water System",
    description: "Platinum Titanium Plates PEM Electrolytic Cell for long life. Production of highly concentrated hydrogen water with 900–1200+ ppb. Zero water wastage with neutral pH output.",
    longDescription: "The PurePro Hydrogen Water Generator uses a PEM (Proton Exchange Membrane) Electrolytic Cell with Platinum Titanium Plates for long life and consistent hydrogen generation. The system produces highly concentrated hydrogen water with more than 1200 ppb through advanced automatic control programming that controls hydrogen generation, dissolution timing, and concentration. Unlike water ionisers, this system produces hydrogen-rich water at a neutral pH (7.2–7.8), making it suitable for everyone. The system operates with zero water wastage – all input water is converted to hydrogen-rich water. At present, this technology is comparable to Nihon Trim Gracia Under-sink systems.",
    features: [
      "PEM Electrolytic Cell Technology",
      "Platinum-Titanium Plates for Long Life",
      "1200+ ppb Hydrogen Concentration",
      "Negative ORP: −400 to −700 mV",
      "Neutral pH Output: 7.2–7.8",
      "Zero Water Wastage",
      "Automatic Control Program",
      "Hydrogen Concentration Control System",
      "Under-Sink Installation",
      "System-Controlled Dissolution Timing",
    ],
    benefits: [
      "Molecular hydrogen is a powerful selective antioxidant",
      "Neutral pH makes it suitable for everyone, including those on medication",
      "Zero water wastage – eco-friendly operation",
      "Under-sink installation keeps countertop clutter-free",
      "Consistent hydrogen concentration through automatic control",
      "Supports over 1,000+ peer-reviewed studies on molecular hydrogen benefits",
    ],
    specifications: [
      { label: "Model", value: "SMSHWT-1500HU" },
      { label: "Hydrogen Concentration", value: "900–1200+ ppb" },
      { label: "ORP", value: "−400 to −700 mV" },
      { label: "pH Output", value: "7.2–7.8 (Neutral)" },
      { label: "Electrolysis Cell", value: "PEM (Platinum-Titanium)" },
      { label: "Water Wastage", value: "Zero" },
      { label: "Installation", value: "Under-Sink" },
      { label: "Control", value: "Automatic Program" },
    ],
    applications: [
      "Under-sink installation for kitchen use",
      "Health-conscious households seeking hydrogen-rich water",
      "Clinics and wellness centres",
      "Individuals who prefer neutral pH water over alkaline",
    ],
    imageUrl: "/images/products/hydrogen-generator.jpg",
  },
  {
    id: "hydrogen-bottle",
    name: "Hydrogen Water Bottle",
    category: "hydrogen",
    tagline: "Portable Hydrogen Water Maker",
    description: "Change water quality in just 3 minutes! Portable hydrogen water bottle produces up to 1431 ppb of dissolved hydrogen. 1.5L of hydrogen water equals the antioxidant value of hundreds of fruits and vegetables.",
    longDescription: "The PurePro Hydrogen Water Bottle is a portable molecular hydrogen generator that transforms ordinary drinking water into hydrogen-rich water in just minutes. At 1 minute you get 854 ppb, at 2 minutes 1145 ppb, and at 3 minutes a remarkable 1431 ppb of dissolved hydrogen. 1.5 litres of hydrogen-rich water provides antioxidant value equivalent to hundreds of servings of fruits and vegetables. The rechargeable design makes it perfect for use at home, in the office, at the gym, or while travelling.",
    features: [
      "3-Minute Hydrogen Generation Cycle",
      "Up to 1431 ppb Hydrogen in 3 Minutes",
      "854 ppb at 1 Minute, 1145 ppb at 2 Minutes",
      "Portable & Rechargeable Design",
      "Premium Build Quality",
      "USB Rechargeable Battery",
      "Food-Grade Materials",
      "One-Touch Operation",
    ],
    benefits: [
      "Portable – use anywhere: home, office, gym, travel",
      "Quick hydrogen generation – ready in 3 minutes",
      "Powerful antioxidant – equivalent to hundreds of fruits & vegetables",
      "Rechargeable for repeated daily use",
      "No filters or cartridges to replace",
      "Molecular hydrogen supports cellular health",
    ],
    specifications: [
      { label: "Type", value: "Portable Hydrogen Water Bottle" },
      { label: "H₂ at 1 min", value: "854 ppb" },
      { label: "H₂ at 2 mins", value: "1145 ppb" },
      { label: "H₂ at 3 mins", value: "1431 ppb" },
      { label: "Power", value: "USB Rechargeable" },
      { label: "Material", value: "Food-Grade" },
      { label: "Operation", value: "One-Touch" },
    ],
    applications: [
      "Daily on-the-go hydrogen water",
      "Gym and fitness hydration",
      "Office use",
      "Travel companion for health-conscious individuals",
    ],
    imageUrl: "/images/products/hydrogen-bottle.jpg",
  },

  // Filters
  {
    id: "shower-filter",
    name: "Shower Filter PRO-6000",
    category: "filters",
    tagline: "Chlorine-Free Shower & Bath",
    description: "Purify your water, rejuvenate your skin, restore your hair's natural shine and lustre, and invigorate your lungs with PurePro Chlorine Shower Filters. Uses patented KDF-55 filtering media.",
    longDescription: "Most people are unaware of the health hazards of showering in unfiltered tap water. Exposure to chlorine and chemicals through inhalation and skin absorption during a shower can be far greater than drinking unfiltered water. The PurePro Shower Filter PRO-6000 uses a patented filtering media – KDF-55 – made of a special high-purity Copper and Zinc alloy. It effectively removes dirt, rust, sediment, odours, chlorine, heavy metals, and more. Enjoy smoother, softer skin, reduce skin rashes, experience less sinus irritation, and healthier hair. Say goodbye to chlorine in your shower and bath!",
    features: [
      "Patented KDF-55 Filtering Media (Copper-Zinc Alloy)",
      "Removes Chlorine, Heavy Metals, Dirt, Rust & Sediment",
      "8,000 Gallon (30,000 Litre) Filter Capacity",
      "Replaceable Cartridge Filter",
      "Anti-Bacteria Carbon – Prevents Bacteria Growth",
      "Unique Date Selection Ring",
      "No Tools Necessary – Installs in Minutes",
      "Standard ½ inch Shower Head Fitting",
      "Premium Chrome Finish",
    ],
    benefits: [
      "Removes chlorine that dries out skin and hair",
      "Smoother, softer skin after every shower",
      "Reduces skin rashes and irritation",
      "Restores hair's natural shine and lustre",
      "Less sinus irritation from chlorine vapour",
      "Protects lungs from inhaling chlorine gas in steam",
      "No tools required for installation – DIY in minutes",
      "Date selection ring helps track filter replacement schedule",
    ],
    specifications: [
      { label: "Model", value: "PRO-6000" },
      { label: "Filter Media", value: "KDF-55 (Copper-Zinc Alloy)" },
      { label: "Carbon Type", value: "Anti-Bacteria Carbon" },
      { label: "Capacity", value: "8,000 Gallons (30,000 Litres)" },
      { label: "Connection", value: "Standard ½ inch" },
      { label: "Installation", value: "No Tools Required" },
      { label: "Finish", value: "Premium Chrome" },
      { label: "Cartridge", value: "Replaceable" },
    ],
    applications: [
      "Home showers and bathrooms",
      "Areas with high chlorine in municipal water",
      "People with sensitive skin, eczema, or dermatitis",
      "Hair care – prevents dryness and colour fading",
      "Hotels and guest houses for premium guest experience",
    ],
    imageUrl: "/images/products/shower-filter.jpg",
  },

  // RO Filters & Spares
  {
    id: "alkaline-filter",
    name: "Alkaline Filter",
    category: "ro-filters",
    tagline: "pH Enhancement Cartridge",
    description: "PurePro USA Alkaline Filter changes acidic RO water into perfect alkaline ionised water with balanced pH 8.0–9.5. Adds essential minerals and improves taste dramatically.",
    longDescription: "The PurePro Alkaline Filter is designed to be added as an additional stage to any RO system. It transforms acidic RO water (typically pH 5–6) into perfectly balanced alkaline ionised water with a pH of 8.0–9.5. The filter uses natural mineral stones and alkaline ceramic balls to raise the pH and add essential minerals including calcium, magnesium, and potassium. This gives your RO water improved taste, better mineral content, and the health benefits associated with alkaline water – all at a fraction of the cost of a standalone water ioniser.",
    features: [
      "Converts Acidic RO Water to Alkaline pH 8.0–9.5",
      "Adds Essential Minerals (Calcium, Magnesium, Potassium)",
      "Natural Mineral Stones & Alkaline Ceramic Balls",
      "Compatible with All RO Systems",
      "Easy Inline Installation",
      "Improves Taste Dramatically",
      "Long Filter Life",
      "Quick-Change Compatible (for ERS series)",
    ],
    benefits: [
      "Affordable way to get alkaline water from your existing RO system",
      "Restores minerals removed by RO purification",
      "Better taste than plain RO water",
      "pH 8.0–9.5 is optimal for daily consumption",
      "Easy to install as an add-on stage",
    ],
    specifications: [
      { label: "Type", value: "Alkaline Enhancement Cartridge" },
      { label: "pH Output", value: "8.0–9.5" },
      { label: "Minerals Added", value: "Calcium, Magnesium, Potassium" },
      { label: "Compatibility", value: "All RO Systems" },
      { label: "Installation", value: "Inline (Post-RO)" },
    ],
    applications: [
      "Add-on stage for existing PurePro RO systems",
      "Upgrade any brand RO system to alkaline output",
      "Replacement cartridge for ERS-106A systems",
    ],
    imageUrl: "/images/alkaline-filter.jpg",
  },
  {
    id: "mineral-filter",
    name: "Mineral Filter",
    category: "ro-filters",
    tagline: "Mineral Enhancement Cartridge",
    description: "Adds essential minerals back to purified water. Provides Calcium (34 mg/L), Magnesium (12 mg/L), Sodium (22 mg/L), and Potassium (7 mg/L) for improved taste and health benefits.",
    longDescription: "The PurePro Mineral Filter is designed to add essential minerals back to RO-purified water. RO membranes effectively remove contaminants but also strip away beneficial minerals. This mineral cartridge replenishes the water with minerals necessary for healthy human development, including Calcium (Ca²⁺: 34 mg/L), Magnesium (Mg²⁺: 12 mg/L), Sodium (Na⁺: 22 mg/L), and Potassium (K⁺: 7 mg/L). These mineral levels are comparable to premium bottled mineral waters. The filter has a capacity of 6,000 litres and is compatible with all RO systems.",
    features: [
      "Adds Calcium, Magnesium, Sodium & Potassium",
      "6,000 Litre Mineral Capacity",
      "Compatible with All RO Systems",
      "Natural Mineral Media",
      "Easy Inline Installation",
      "Improves Water Taste Significantly",
      "Long-Lasting Cartridge",
      "Quick-Change Compatible (for ERS series)",
    ],
    benefits: [
      "Restores essential minerals removed by RO purification",
      "Mineral levels comparable to premium bottled mineral waters",
      "Better taste and mouthfeel than plain RO water",
      "Supports bone health (calcium), muscle function (magnesium), and hydration (potassium)",
      "Cost-effective way to get mineral water at home",
    ],
    specifications: [
      { label: "Type", value: "Mineral Enhancement Cartridge" },
      { label: "Calcium (Ca²⁺)", value: "34 mg/L" },
      { label: "Magnesium (Mg²⁺)", value: "12 mg/L" },
      { label: "Sodium (Na⁺)", value: "22 mg/L" },
      { label: "Potassium (K⁺)", value: "7 mg/L" },
      { label: "Capacity", value: "6,000 Litres" },
      { label: "Compatibility", value: "All RO Systems" },
      { label: "Installation", value: "Inline (Post-RO)" },
    ],
    applications: [
      "Add-on stage for existing PurePro RO systems",
      "Upgrade any brand RO system for mineral-enriched output",
      "Replacement cartridge for ERS-106M systems",
    ],
    imageUrl: "/images/mineral-filter.jpg",
  },

  // Perfect Water Series
  {
    id: "pj-103",
    name: "Perfect Water PJ-103",
    category: "perfect-water",
    tagline: "RO + Water Ioniser – The Best of Both Worlds",
    description: "A combination of the best of both worlds – RO purification combined with Water Ioniser technology. Get perfectly clean AND perfectly healthy alkaline ionised water from one system.",
    longDescription: "More and more people understand that the 'perfect water' system would combine the purity of Reverse Osmosis (RO) and the tremendous benefits provided by alkaline ionised water. Historically, this has not been easily achieved for a variety of reasons. PurePro's water technology experts have solved the problem of combining these two phenomenal yet very different water technologies. Now you can have perfectly clean AND perfectly healthy water by installing the PJ-103! The system features a complete RO purification unit paired with a 3-plate water ioniser, giving you four levels of alkaline water, two levels of acid water (including super-oxide), and filter water (non-ionised) through the Reverse Osmosis system.",
    features: [
      "RO Purification + Water Ioniser in One System",
      "3-Plate Ioniser with Platinum-Titanium Electrodes",
      "Four Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Filter Water (non-ionised) by RO System",
      "50 GPD RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Stainless Steel Output Spout",
      "Built-in Auto-Flushing Electrode",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "Best of both worlds – pure RO water + alkaline ionisation",
      "Eliminates the need for two separate systems",
      "RO removes all contaminants; ioniser adds health benefits",
      "Space-saving single-system solution",
      "Acid water for skin care and household cleaning",
    ],
    specifications: [
      { label: "Model", value: "PJ-103" },
      { label: "System", value: "RO + 3-Plate Water Ioniser" },
      { label: "RO Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
      { label: "Ioniser Plates", value: "3 Platinum-Titanium" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Families wanting both RO purity and alkaline benefits",
      "Entry-level Perfect Water system",
      "Under-sink residential installation",
    ],
    imageUrl: "/images/perfect-water-pj-103.jpg",
  },
  {
    id: "pj-103p",
    name: "Perfect Water PJ-103P",
    category: "perfect-water",
    tagline: "RO with Pump + Water Ioniser",
    description: "A combination of the best of both worlds – RO with built-in pump + Water Ioniser. Designed for areas with low water pressure where a standard RO system may not function efficiently.",
    longDescription: "The PJ-103P combines RO purification with a built-in booster pump and a 3-plate water ioniser. The built-in pump makes this system ideal for areas with low water pressure (below 50 psi) where a standard RO system may not function efficiently. You get perfectly clean AND perfectly healthy alkaline ionised water regardless of your water pressure conditions.",
    features: [
      "Built-in Booster Pump for Low Pressure Areas",
      "RO Purification + Water Ioniser in One System",
      "3-Plate Ioniser with Platinum-Titanium Electrodes",
      "Four Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "50 GPD RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Works with Water Pressure as Low as 10 psi",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "Operates in low water pressure areas (apartments, high-rise buildings)",
      "Same benefits as PJ-103 with added pump functionality",
      "No external pump purchase required",
      "Reliable RO purification regardless of inlet pressure",
    ],
    specifications: [
      { label: "Model", value: "PJ-103P" },
      { label: "System", value: "RO with Pump + 3-Plate Water Ioniser" },
      { label: "Pump", value: "Built-in Booster Pump" },
      { label: "RO Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
      { label: "Ioniser Plates", value: "3 Platinum-Titanium" },
      { label: "Min. Input Pressure", value: "~10 psi" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Low water pressure areas – apartments, high-rise buildings",
      "Areas with inconsistent municipal water pressure",
      "Under-sink installation with pump support",
    ],
    imageUrl: "/images/perfect-water-pj-103p.jpg",
  },
  {
    id: "pj-503",
    name: "Perfect Water PJ-503",
    category: "perfect-water",
    tagline: "RO + 5-Plate Water Ioniser",
    description: "Premium combination of RO purification + 5-plate Water Ioniser for enhanced ionisation. Hydrogen-rich alkaline water with the purity of Reverse Osmosis.",
    longDescription: "The PJ-503 is a premium Perfect Water system combining complete RO purification with a powerful 5-plate water ioniser (JA-503). This system delivers hydrogen-rich, alkaline ionised water that has been pre-purified through a multi-stage RO process. With 5 platinum-titanium plates, it offers enhanced ionisation strength compared to the PJ-103, producing higher pH and more negative ORP for superior antioxidant benefits.",
    features: [
      "5-Plate Ioniser with Platinum-Titanium Electrodes",
      "RO Purification + Water Ioniser Combined",
      "Enhanced Ionisation with 750 cm² Chamber",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Hydrogen-Rich Water Output",
      "50 GPD RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Stainless Steel Output Spout",
      "Built-in Auto-Flushing Electrode",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "5-plate system provides stronger ionisation than PJ-103",
      "Higher hydrogen concentration for better antioxidant benefits",
      "Complete purification + ionisation in one system",
      "No water quality compromise – RO removes all contaminants first",
    ],
    specifications: [
      { label: "Model", value: "PJ-503" },
      { label: "System", value: "RO + 5-Plate Water Ioniser (JA-503)" },
      { label: "RO Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Ioniser Plates", value: "5 Platinum-Titanium" },
      { label: "Electrolysis Chamber", value: "750 cm²" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Families seeking premium ionised water with RO purity",
      "Mid-range Perfect Water system for health-conscious households",
      "Under-sink residential installation",
    ],
    imageUrl: "/images/perfect-water-pj-503.jpg",
  },
  {
    id: "pj-503p",
    name: "Perfect Water PJ-503P",
    category: "perfect-water",
    tagline: "RO with Pump + 5-Plate Ioniser",
    description: "Premium combination of RO with built-in pump + 5-plate Water Ioniser. Designed for low water pressure areas with enhanced ionisation performance.",
    longDescription: "The PJ-503P combines a 5-plate water ioniser with RO purification and a built-in booster pump. Ideal for areas with low water pressure, this system delivers hydrogen-rich, alkaline ionised water regardless of your inlet pressure conditions. The 5-plate ioniser provides superior ionisation strength compared to 3-plate models.",
    features: [
      "Built-in Booster Pump for Low Pressure Areas",
      "5-Plate Ioniser with Platinum-Titanium Electrodes",
      "RO Purification + Water Ioniser Combined",
      "Five Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Hydrogen-Rich Water Output",
      "50 GPD RO Membrane (Made in USA)",
      "3.2 Gallon NSF Standards Water Storage Tank",
      "Works with Low Inlet Pressure (~10 psi)",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "Perfect for low pressure areas with pump support",
      "5-plate ionisation for premium hydrogen-rich water",
      "All-in-one system – no separate pump needed",
    ],
    specifications: [
      { label: "Model", value: "PJ-503P" },
      { label: "System", value: "RO with Pump + 5-Plate Water Ioniser" },
      { label: "Pump", value: "Built-in Booster Pump" },
      { label: "RO Membrane", value: "50 GPD / 189 LPD (Made in USA)" },
      { label: "Ioniser Plates", value: "5 Platinum-Titanium" },
      { label: "Electrolysis Chamber", value: "750 cm²" },
      { label: "Tank Capacity", value: "3.2 Gallons (NSF Standards)" },
      { label: "Min. Input Pressure", value: "~10 psi" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Low water pressure areas – apartments, high-rise buildings",
      "Premium ionised water with pump assistance",
    ],
    imageUrl: "/images/perfect-water-pj-503p.jpg",
  },
  {
    id: "pj-703",
    name: "Perfect Water PJ-703",
    category: "perfect-water",
    tagline: "RO + 7-Plate Water Ioniser – Flagship",
    description: "The ultimate combination – RO purification + 7-plate JA-703 Water Ioniser. Maximum ionisation with 1368 cm² electrolysis chamber for the highest pH and most negative ORP.",
    longDescription: "The PJ-703 is the flagship of the Perfect Water Series, combining complete RO purification with the most powerful PurePro water ioniser – the JA-703 with 7 platinum-titanium plates. This system features an electrolysis chamber area of 1368 cm² and produces ionised water of about 11.00 pH or higher with ORP levels reaching −700 mV. It delivers four levels of alkaline water, two levels of acid water (including super-oxide), and filter water (non-ionised) through the RO system. The stainless steel output spout and built-in auto-flushing electrode ensure premium performance and longevity.",
    features: [
      "7-Plate Ioniser (JA-703) – Most Powerful in Range",
      "Electrolysis Chamber: 1368 cm²",
      "RO Purification + Water Ioniser Combined",
      "pH up to 11.0+ with ORP to −700 mV",
      "Four Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Maximum Hydrogen Gas Production",
      "NF Membrane (retains essential minerals)",
      "Stainless Steel Output Spout",
      "Built-in Auto-Flushing Electrode",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "Maximum ionisation power with 7-plate JA-703 technology",
      "Highest pH and most negative ORP in the Perfect Water range",
      "Complete purification – contaminant-free alkaline water",
      "NF membrane retains minerals for better ionisation",
      "Flagship system for ultimate water quality",
    ],
    specifications: [
      { label: "Model", value: "PJ-703" },
      { label: "System", value: "RO + 7-Plate Water Ioniser (JA-703)" },
      { label: "Ioniser Plates", value: "7 Platinum-Titanium (99.97% pure)" },
      { label: "Electrolysis Chamber", value: "1368 cm²" },
      { label: "RO/NF Membrane", value: "ERS-105-NF" },
      { label: "pH Range", value: "Up to 11.0+" },
      { label: "ORP Level", value: "+500 mV to −700 mV" },
      { label: "Ioniser Voltage", value: "AC-110V / AC-220V" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "Ioniser Dimensions", value: "31.5 (H) × 25.5 (W) × 13.5 (L) cm" },
      { label: "Ioniser Weight", value: "5.5 kg" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Flagship system for health-conscious families",
      "Ultimate water quality – purity + maximum ionisation",
      "Wellness centres and health clinics",
      "Under-sink residential installation",
    ],
    imageUrl: "/images/perfect-water-pj-703.jpg",
  },
  {
    id: "pj-703p",
    name: "Perfect Water PJ-703P",
    category: "perfect-water",
    tagline: "RO with Pump + 7-Plate Ioniser – Top of the Line",
    description: "The ultimate top-of-the-line system – RO with built-in pump + 7-plate JA-703 Water Ioniser. Flagship performance even in low water pressure areas.",
    longDescription: "The PJ-703P is the absolute top-of-the-line Perfect Water system, combining the flagship 7-plate JA-703 ioniser with RO purification and a built-in booster pump. This system delivers the maximum ionisation performance (pH 11.0+, ORP −700 mV) regardless of your water pressure conditions. Ideal for apartments, high-rise buildings, or any location with inconsistent water pressure.",
    features: [
      "7-Plate Ioniser (JA-703) – Most Powerful in Range",
      "Built-in Booster Pump for Low Pressure Areas",
      "Electrolysis Chamber: 1368 cm²",
      "RO Purification + Water Ioniser Combined",
      "pH up to 11.0+ with ORP to −700 mV",
      "Four Levels of Alkaline Water",
      "Two Levels of Acid Water (including super-oxide)",
      "Maximum Hydrogen Gas Production",
      "NF Membrane (retains essential minerals)",
      "Works with Low Inlet Pressure (~10 psi)",
      "100% Factory Tested & Sterilised",
    ],
    benefits: [
      "Top-of-the-line system with maximum ionisation + pump support",
      "No water pressure limitations – works anywhere",
      "7-plate technology for the best antioxidant water",
      "All-in-one flagship solution",
    ],
    specifications: [
      { label: "Model", value: "PJ-703P" },
      { label: "System", value: "RO with Pump + 7-Plate Water Ioniser (JA-703)" },
      { label: "Pump", value: "Built-in Booster Pump" },
      { label: "Ioniser Plates", value: "7 Platinum-Titanium (99.97% pure)" },
      { label: "Electrolysis Chamber", value: "1368 cm²" },
      { label: "RO/NF Membrane", value: "ERS-105-NF" },
      { label: "pH Range", value: "Up to 11.0+" },
      { label: "ORP Level", value: "+500 mV to −700 mV" },
      { label: "Min. Input Pressure", value: "~10 psi" },
      { label: "Power Consumption", value: "100–200W" },
      { label: "Ioniser Dimensions", value: "31.5 (H) × 25.5 (W) × 13.5 (L) cm" },
      { label: "Ioniser Weight", value: "5.5 kg" },
      { label: "Installation", value: "Under-Sink" },
    ],
    applications: [
      "Low pressure areas requiring flagship ionisation",
      "Apartments and high-rise buildings",
      "The ultimate home water solution – no compromises",
    ],
    imageUrl: "/images/perfect-water-pj-703p.jpg",
  },
];

export const productCategories = [
  { id: "all", label: "All Products" },
  { id: "ionizers", label: "Water Ionisers" },
  { id: "ro-systems", label: "RO Systems" },
  { id: "perfect-water", label: "Perfect Water Series" },
  { id: "hydrogen", label: "Hydrogen Products" },
  { id: "filters", label: "Shower Filters" },
  { id: "ro-filters", label: "RO Filters & Spares" },
];

export const companyInfo = {
  name: "Pure Pro India",
  fullName: "PurePro Water Corporation",
  tagline: "World's #1 Water Treatment Manufacturer & Exporter",
  description: "Pure-Pro Water Corporation was established to supply high quality water treatment systems and accessories. We are specialized in manufacturing a variety of standard and customized Reverse Osmosis (RO) Water Filtration, Membranes and Water Ionizers.",
  madeIn: "Made in the USA & Taiwan",
  experience: "Over 20 years expertise in reverse osmosis drinking water systems",
  mission: "To provide the highest quality of service and products in the water treatment industry.",
  
  contact: {
    headOffice: {
      address: "Vipul Trade Center, Sector 48, Sohna Road, Gurugram, Haryana 122018",
      city: "Gurugram",
    },
    email: "support@pureproindia.in",
    website: "www.pureproindia.in",
    phone: "+91 9711808331",
    whatsapp: "919711808331",
  },

  branches: [
    "Head Office - Gurugram",
    "Jaipur",
    "Ahmedabad",
    "Amritsar",
    "Mumbai",
    "Aligarh",
    "Bangalore",
    "Hyderabad",
    "Pune",
  ],

  productLines: [
    { name: "Water Ionisers", category: "ionizers" },
    { name: "RO Systems", category: "ro-systems" },
    { name: "Perfect Water Series", category: "perfect-water" },
    { name: "Hydrogen Products", category: "hydrogen" },
    { name: "Shower Filters", category: "filters" },
    { name: "RO Filters & Spares", category: "ro-filters" },
  ],
};
